export enum ThreePointsActionType {
  SET_THREE_POINTS = 'SET_THREE_POINTS',
}
